import { mulDivRound } from './rounding'

export interface CostMovement {
  qtyMilli: number
  unitCostPaisa: number
  /** Bought or counted in (`receipt`, `opening`), as against a return or a transfer. */
  costed: boolean
}

export interface MovingCost {
  qtyMilli: number
  /** Value of `qtyMilli` at the average, in paisa. */
  cost: number
}

/**
 * The moving average cost after a product's movements, oldest first. Each costed delivery blends
 * with what is on hand; stock leaving keeps the average. At zero or below nothing is left to blend,
 * so the next delivery starts it afresh. A blank (zero) cost keeps the average too. Null when no
 * delivery ever had a cost. `qtyMilli` is what was on hand after the last costed delivery.
 */
export function movingCost(movements: readonly CostMovement[]): MovingCost | null {
  let onHand = 0
  let basis: MovingCost | null = null
  for (const m of movements) {
    if (m.costed && m.qtyMilli > 0 && m.unitCostPaisa > 0) {
      const kept: number = basis && onHand > 0 ? mulDivRound(basis.cost, onHand, basis.qtyMilli) : 0
      const keptQty: number = Math.max(onHand, 0)
      basis = {
        qtyMilli: keptQty + m.qtyMilli,
        cost: kept + mulDivRound(m.qtyMilli, m.unitCostPaisa, 1000),
      }
    }
    onHand += m.qtyMilli
  }
  return basis
}
